var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import * as React from "react";
import { useState } from "react";
import { Grid, Typography, Dialog, DialogActions, DialogContent, Zoom, } from "@mui/material";
import { Formik } from "formik";
// import { useDispatch } from 'react-redux';
// import API from '../../../api';
// import * as actionTypes from '../../../store/actions';
import { dialog } from "../../utils/componentWizard";
import { useNotify, } from "react-admin";
import popupStyles from "../../styles/popup/popup.module.css";
var classes = {
    noMarginDialog: {
        "&>div:nth-child(3)": {
            "&>div": {
                margin: 0,
            },
        },
    },
};
var Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Zoom, __assign({ ref: ref }, props));
});
var EditDialog = function (_a) {
    var opened = _a.opened, data = _a.data, closeDialog = _a.closeDialog, translate = _a.translate, reloadRecord = _a.reloadRecord, isMobileScreen = _a.isMobileScreen;
    var notify = useNotify();
    var _b = useState(false), nameChanged = _b[0], setNameChanged = _b[1];
    // Check if any values have changed from initial state
    var hasValuesChanged = function (currentValues, initialValues) {
        return Object.keys(currentValues).some(function (key) { var _a, _b; return ((_a = currentValues[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== ((_b = initialValues[key]) === null || _b === void 0 ? void 0 : _b.toString()); });
    };
    // Validate form values based on dialog type
    var validateValues = function (values) {
        var isCreateMode = data.dialogType === "Create";
        var initialValues = data.data || {};
        // For Create mode
        if (isCreateMode) {
            var requiredFields = ['name', 'quota', 'price'];
            var missingRequired = requiredFields.some(function (field) { return !values[field]; });
            if (missingRequired) {
                notify(translate("common.fillInAll"), { type: 'warning' });
                return false;
            }
            return true;
        }
        // For Edit mode
        if (!hasValuesChanged(values, initialValues)) {
            notify(translate("common.noChanges"), { type: 'warning' });
            return false;
        }
        // If name was changed, ensure it's not empty
        if (nameChanged && !values.name) {
            notify(translate("common.fillInAll"), { type: 'warning' });
            return false;
        }
        return true;
    };
    // Prepare values for submission
    var prepareSubmitValues = function (values, isEdit) {
        var prepared = {
            name: values.name,
            description: values.description || "",
            quota: parseInt(values.quota),
            price: parseInt(values.price)
        };
        if (isEdit) {
            var initialValues_1 = data.data || {};
            var changedValues_1 = {};
            Object.keys(prepared).forEach(function (key) {
                var _a, _b;
                if (((_a = prepared[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== ((_b = initialValues_1[key]) === null || _b === void 0 ? void 0 : _b.toString())) {
                    changedValues_1[key] = prepared[key];
                }
            });
            return changedValues_1;
        }
        return prepared;
    };
    return (_jsx(React.Fragment, { children: _jsxs(Dialog, { open: opened, TransitionComponent: Transition, onClose: closeDialog, className: classes.noMarginDialog, keepMounted: true, sx: {
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                "& .MuiDialog-paper": {
                    borderRadius: "30px",
                    backgroundColor: "#F5F5F5",
                    padding: "0.5em",
                },
            }, children: [_jsx(dialog.header, { title: translate("dialog.".concat(data.dialogType)), handleClose: closeDialog }), _jsx(Formik, { enableReinitialize: true, initialValues: data.data || {}, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                        var submitValues, err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    if (!validateValues(values)) {
                                        return [2 /*return*/];
                                    }
                                    submitValues = prepareSubmitValues(values, data.dialogType === "Edit");
                                    return [4 /*yield*/, reloadRecord(submitValues, data)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _a.sent();
                                    console.error("Submit error:", err_1);
                                    notify(translate('error.common.tryAgain'), { type: 'error' });
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, children: function (props) {
                        var handleSubmit = props.handleSubmit, setFieldValue = props.setFieldValue;
                        var isEdit = data.dialogType === "Edit";
                        return (_jsxs("form", { noValidate: true, onSubmit: handleSubmit, children: [_jsxs(DialogContent, { className: popupStyles.dialogContent, children: [_jsxs(Grid, { container: true, className: popupStyles.container, display: "flex", flexWrap: "wrap", children: [_jsxs(Grid, { item: true, xs: 12, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { xs: 12, md: 4, children: _jsxs(Typography, { className: "".concat(popupStyles.field, " small-text large-bold"), style: { textAlign: isMobileScreen ? "center" : "end" }, paddingX: 2, children: [translate("pages.package.fields.name"), " ", !isEdit && "*"] }) }), _jsx(Grid, { xs: 10, md: 6, children: _jsx(dialog.textField, { form: props, name: "name", fullWidth: true, required: !isEdit, onChange: function (e) {
                                                                    setFieldValue('name', e.target.value);
                                                                    setNameChanged(true);
                                                                }, helperText: isEdit ? translate('pages.package.helper.nameEdit') : '' }) })] }), _jsxs(Grid, { item: true, xs: 12, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { xs: 12, md: 4, children: _jsx(Typography, { className: "".concat(popupStyles.field, " small-text large-bold"), style: { textAlign: isMobileScreen ? "center" : "end" }, paddingX: 2, children: translate("pages.package.fields.description") }) }), _jsx(Grid, { xs: 10, md: 6, children: _jsx(dialog.textField, { form: props, name: "description", fullWidth: true }) })] }), _jsxs(Grid, { item: true, xs: 12, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { xs: 12, md: 4, children: _jsxs(Typography, { className: "".concat(popupStyles.field, " small-text large-bold"), style: { textAlign: isMobileScreen ? "center" : "end" }, paddingX: 2, children: [translate("pages.package.fields.quota"), " ", !isEdit && "*"] }) }), _jsx(Grid, { xs: 10, md: 6, children: _jsx(dialog.textField, { form: props, name: "quota", fullWidth: true, required: !isEdit, type: "number" }) })] }), _jsxs(Grid, { item: true, xs: 12, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { xs: 12, md: 4, children: _jsxs(Typography, { className: "".concat(popupStyles.field, " small-text large-bold"), style: { textAlign: isMobileScreen ? "center" : "end" }, paddingX: 2, children: [translate("pages.package.fields.price"), " ", !isEdit && "*"] }) }), _jsx(Grid, { xs: 10, md: 6, children: _jsx(dialog.textField, { form: props, name: "price", fullWidth: true, required: !isEdit, type: "number" }) })] })] }), _jsx(Grid, { item: true, xs: 12, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", children: _jsx(dialog.submitButton, { isSubmitting: props.isSubmitting, text: translate("dialog.submit") }) })] }), _jsx(DialogActions, {})] }));
                    } })] }) }));
};
export default EditDialog;
